import { useConfig as hook, BaseConfig } from '@eika-infrastruktur/config-provider';
import Dictionary from './static/data/Dictionary';

interface Config extends BaseConfig {
    texts: typeof Dictionary;
    siteLang: 'nb' | 'en';
}

export const DefaultConfig: Config = {
    texts: Dictionary,
    siteLang: 'nb' as const,
    setSiteLang: () => {},
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof DefaultConfig>();
